import { render, staticRenderFns } from "./userSign.vue?vue&type=template&id=3127df6f&scoped=true"
import script from "./userSign.vue?vue&type=script&lang=js"
export * from "./userSign.vue?vue&type=script&lang=js"
import style0 from "./userSign.vue?vue&type=style&index=0&id=3127df6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127df6f",
  null
  
)

export default component.exports